<script setup>
import { ref } from 'vue';
import FoldingGroup from 'dashboard/components-next/polaris/cards/FoldingGroup.vue';

// Rebuilt inside on the kit's FoldingGroup (phase 9.4): a titled group that folds. Same props and slot.
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultOpen: {
    type: Boolean,
    default: true,
  },
});

const isOpen = ref(props.defaultOpen);
</script>

<template>
  <FoldingGroup
    v-model:open="isOpen"
    :title="title"
    class="w-full border-0 border-t border-solid border-polaris-border pt-4"
  >
    <div class="w-full space-y-4">
      <slot />
    </div>
  </FoldingGroup>
</template>
